import React, { useEffect, useRef } from 'react';
import { Check, Lock, Archive } from 'lucide-react';

export const ProgramDayStrip = ({ days, selected, currentDay, completedDays, unlockedAll, onSelect, dayLabel, streak = 0, expanding = false }) => {
  const ref = useRef(null);
  useEffect(() => {
    ref.current?.querySelector(`[data-day="${selected}"]`)?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }, [selected]);
  return (
    <div ref={ref} className="flex gap-2 overflow-x-auto pb-2 -mx-5 px-5 scrollbar-none" data-testid="program-day-strip">
      {days.map((d) => {
        const n = d.dayNumber;
        const done = completedDays.has(n);
        const locked = !unlockedAll && n > currentDay;
        const active = n === selected;
        const archived = !!d.archived;
        const glow = done && n <= streak && !archived;
        return (
          <button key={d.id} type="button" data-day={n} onClick={() => onSelect(n)} data-testid={`day-pill-${n}`} data-glow={glow ? '1' : undefined}
            className={`flex-shrink-0 w-14 h-16 rounded-2xl flex flex-col items-center justify-center border transition-[background-color,border-color,transform] duration-300 active:scale-95 ${glow ? 'streak-glow' : ''} ${expanding && glow ? 'streak-expand' : ''} ${
              active ? 'bg-[#D6AD60] text-[#0f1e33] border-[#D6AD60]' : done ? 'bg-[#7a9b8e]/30 text-[#dfeee6] border-[#7a9b8e]/50' : locked ? 'bg-white/10 text-white/40 border-white/10' : 'bg-white/85 text-[#1e3a5f] border-[#e3d2a8]/60'
            } ${archived ? 'opacity-50' : ''}`} data-archived={archived ? '1' : undefined}>
            <span className="text-[9px] uppercase tracking-widest opacity-70">{dayLabel}</span>
            <span className="text-base font-bold leading-none mt-0.5">{n}</span>
            <span className="h-3 mt-1">{archived ? <Archive className="w-3 h-3" /> : done ? <Check className="w-3 h-3" /> : locked ? <Lock className="w-3 h-3" /> : null}</span>
          </button>
        );
      })}
    </div>
  );
};
